<!-- 我的课程 -->
<template>
  <div class="el-MyCourse_t">
    <el-row class="content_block mb30 p10">
      <ul class="ulClass">
        <li>
          <template v-if="userType == 1">
            <el-image class="jiarukec_img c_p" :src="jiarukec" @click="showAdd"></el-image>
            <p>
              <el-button type="primary" @click="showAdd">加入课程</el-button>
            </p>
          </template>
          <template v-if="userType == 2">
            <el-image class="jiarukec_img c_p" :src="jiarukec" @click="showAddCourse"></el-image>
            <p>
              <el-button type="primary" @click="showAddCourse">新增开课</el-button>
            </p>
          </template>
        </li>
        <template v-for="(item, index) in courseList">
          <li :key="index" @mouseenter="onMouseOver(index)"  @mouseleave="onMouseOut">
            <el-row style="position: relative;">
              <el-image class="course_img" :src="$isHttp(item.teacherOpenCourseCover)"></el-image>
              <el-row v-show="userType == 2 && onCourse == index" class="course_img hover_course_img">
                <el-col :span="8" class="t_r">
                  <el-image class="course_min_img c_p" @click="move(item,'MOVE_TOP')" :src="zhiding"></el-image>
                  <p style="margin-right: 3px;">置顶</p>
                </el-col>
                <el-col :span="8">
                  <el-image class="course_min_img c_p" @click="move(item,'MOVE_LEFT')" :src="qianyi"></el-image>
                  <p>前移</p>
                </el-col>
                <el-col :span="8" class="tl">
                  <el-image class="course_min_img c_p" @click="move(item,'MOVE_RIGHT')" :src="houyi"></el-image>
                  <p class="ml5">后移</p>
                </el-col>
              </el-row>
              <template v-if="userType == 2 && onCourse == index">
                <el-row class="cz_li">
                  <el-col :span="12" class="tc" style="border-right: 1px solid white;">
                    <el-link style="color: white;" @click="editCourse(item)" :underline="false" type="primary">编辑</el-link>
                  </el-col>
                  <el-col :span="12" class="tc" >
                    <el-link style="color: white;" @click="delCourse(item)" :underline="false" type="primary">删除</el-link>
                  </el-col>
                </el-row>
              </template>
              <p class="limit_line_one tl fontB m10 c_p" @click="courseInon(item)">{{item.teacherOpenCourseTitle}}</p>
              <p class="limit_line_one tl mt5 mb10 ml10 mr10 c_p" style="font-size: 13px;" @click="courseInon(item)">本课程共 {{item.courseInfoCount || '-'}} 章</p>
              <div style="line-height: 20px;font-size: 13px;" class="courseSummary limit_line_two tl mt5 mb10 ml10 mr10 c_p" @click="courseInon(item)" v-html="item.teacherOpenCourseSummary">

              </div>
            </el-row>
          </li>
        </template>
      </ul>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[9, 18, 27, 100]"
        :page-size="limit"
        background
        style="width: 98%;float: right;text-align:right;padding: 20px;"
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </el-row>

    <!-- 加入课程对话框 -->
    <el-dialog
      title="加入课程"
      :modal="false"
      :visible.sync="show_course"
      width="500px"
    >
      <span slot="title">
        <i class="el-icon-data-analysis" style="margin-right: 10px;color: #f9c75a;font-size: 20px;"></i>加入课程
      </span>
      <el-row class="mb40">
        <p>课程授权码：</p>
        <el-input v-model="courseNo" placeholder="请输入课程授权码"></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_course = false">取 消</el-button>
        <el-button type="primary" @click="submitAddCourse">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增开课 -->
    <el-dialog
      title="新增开课"
      :modal="false"
      :visible.sync="addCourseShow"
      width="700px"
    >
      <el-form ref="form" :model="addInfo" label-width="80px">
        <el-form-item label="开课名称">
          <el-input v-model="addInfo.teacherOpenCourseTitle"></el-input>
        </el-form-item>
        <!-- <el-form-item label="课程编码">
          <el-input v-model="addInfo.teacherOpenCourseCode"></el-input>
        </el-form-item> -->
        <el-form-item label="课程封面">
          <UploadImage
            ref="picture"
            v-if="addCourseShow"
            :upload-style="{
              width: '164px',
              height: '89px',
              border:'1px solid #DCDFE6'
            }"
            @onSuccess="value => addInfo.teacherOpenCourseCover = value"
          />
          <el-button type="warning" @click="seeSysImgsInfo" style="position: absolute;top: 20px;left: 200px;">选择默认封面</el-button>
        </el-form-item>
        <el-form-item label="开课时间">
          <el-date-picker
            v-model="addInfo.kksj"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="默认封面">
          <template v-for="(item, index) in sysImgsInfo">
            <el-row style="float: left;margin: 0 10px 10px 0;position: relative;width: 164px;height: 89px;">
              <el-image class="c_p" @click="seeImg(index,item)" style="width: 164px;height: 89px;" :src="item"></el-image>
              <div v-if="index == onImg" @click="seeImg(index,item)" class="c_p" style="position: absolute;background-color: #000000;;width: 100%;height: 100%;top: 0;opacity:0.2"></div>
              <i  v-if="index == onImg" class="el-icon-circle-check font30" style="position: absolute;top: 2px;right: 2px;color: #FFFFFF;"></i>
            </el-row>
          </template>
        </el-form-item> -->
        <el-form-item label="简介">
          <RichText ref="richText" v-if="addCourseShow" v-model="addInfo.teacherOpenCourseSummary" />
        </el-form-item>
      </el-form>
      <span slot="title">
        <i class="el-icon-data-analysis" style="margin-right: 10px;color: #f9c75a;font-size: 20px;"></i>
        {{addInfo.teacherOpenCourseId?'编辑课程':"新增开课"}}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCourseShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAddInfo">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="选择默认封面"
      :modal="false"
      :visible.sync="show_sysImgsInfo"
      width="700px"
    >
      <el-row>
        <template v-for="(item, index) in sysImgsInfo">
          <el-row style="float: left;margin: 0 10px 10px 0;position: relative;width: 147px;height: 80px;">
            <el-image class="c_p" @click="seeImgOk(index,item)" style="width: 147px;height: 80px;" :src="$isHttp(item)"></el-image>
            <div v-if="index == onImg" @click="seeImgOk(index,item)" class="c_p" style="position: absolute;background-color: #000000;;width: 100%;height: 100%;top: 0;opacity:0.2"></div>
            <i  v-if="index == onImg" class="el-icon-circle-check font30" style="position: absolute;top: 2px;right: 2px;color: #FFFFFF;"></i>
          </el-row>
        </template>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_sysImgsInfo = false">取 消</el-button>
        <el-button type="primary" @click="submitSeeImgOk">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import houyi from '@/images/course/houyi@2x.png';
import jiarukec from '@/images/course/jiarukec@2x.png';
import qianyi from '@/images/course/qianyi@2x.png';
import zhiding from '@/images/course/zhiding@2x.png';
import UploadImage from "@/components/UploadImage";	//上传图片
import RichText from '@/components/RichText/index';
export default {
  name: "MyCourse",
  components: {
    UploadImage,
    RichText
  },
  data() {
    return {
      activeName:"first",
      houyi:houyi,
      jiarukec:jiarukec,
      qianyi:qianyi,
      zhiding:zhiding,
      courseList:[],
      onCourse:-1,
      show_course:false,
      courseNo:"",
      userType:this.$Base64.decode(this.$ls.get(this.$getKeyInfo("userType"))),
      addCourseShow:false,
      addInfo:{},
      imageUrl: '',
      onImg:-1,
      total: null,
      limit:9,
      page:1,
      sysImgsInfo:[], //默认图片
      show_sysImgsInfo:false,
    };
  },
  created() {
    this.getInfo();
    this.sysImgs();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    sysImgs(){
      this.$get("/api/base/sysImgs.do").then((ret) =>{
        if(ret.code == 0){
          this.sysImgsInfo = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    seeSysImgsInfo(){ //选择默认封面
      this.show_sysImgsInfo = true;
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
      }
      this.$post("/jlw/teacherOpenCourse/list.json",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.courseList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    courseInon(item){
      this.$ls.remove(this.$getKeyInfo('on_show'));
      if(this.userType == 1){
        this.$router.push({name:'CourseHome',query:{teacherOpenCourseId:item.teacherOpenCourseId}});
      }else{
        this.$router.push({name:'TCourseHome',query:{teacherOpenCourseId:item.teacherOpenCourseId}});
      }
    },
    onMouseOver(index){ //鼠标移入
      this.onCourse = index;
    },
    onMouseOut(){ //鼠标移出
      this.onCourse = -1;
    },
    showAdd(item){ //开始加入课程
      this.courseNo = "";
      this.show_course = true;
    },
    submitAddCourse(){ //提交加入课程
      if(this.$isEmpty(this.courseNo)){
        this.$message.warning("请输入课程授权码！");
        return;
      }
      let param = {
        teacherOpenCourseMergeTeacherAuthCode:this.courseNo
      }
      this.$post("/api/teacherOpenCourseMergeStudent/joinCourse.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.show_course = false;
          this.$message.success("加入成功！");
        }else{
          this.$message.error(ret.msg);
        }
      });

    },
    showAddCourse(){
      this.addInfo = {};
      this.onImg = -1;
      this.addCourseShow = true;
    },
    seeImg(index){
      if(this.onImg == index){
        setTimeout(()=>{
          this.$refs.picture.imageUrl = "";
        },10);
        this.onImg = -1;
      }else{
        setTimeout(()=>{
          this.$refs.picture.imageUrl = this.$isHttp(this.sysImgsInfo[index]);
        },10);
        this.onImg = index;
      }
    },
    seeImgOk(index){
      if(this.onImg == index){
        this.onImg = -1;
      }else{
        this.onImg = index;
      }
    },
    submitSeeImgOk(){
      if(this.onImg == -1){
        setTimeout(()=>{
          this.$refs.picture.imageUrl = "";
        },10);
        this.onImg = -1;
      }else{
        setTimeout(()=>{
          this.$refs.picture.imageUrl = this.$isHttp(this.sysImgsInfo[this.onImg]);
        },10);
      }
      this.show_sysImgsInfo = false;
    },
    submitAddInfo(){
      if(this.$isEmpty(this.addInfo.teacherOpenCourseTitle)){
        this.$message({message: '请输入开课名称！',type: 'warning'});
        return;
      }
      // if(this.$isEmpty(this.addInfo.teacherOpenCourseCode)){
      //   this.$message({message: '请输入课程编号！',type: 'warning'});
      //   return;
      // }
      if(this.$isEmpty(this.addInfo.teacherOpenCourseCover) && this.onImg == -1){
        this.$message({message: '请上传或者选择默认课程封面！',type: 'warning'});
        return;
      }
      if(this.onImg >= 0){
        this.addInfo.teacherOpenCourseCover = this.sysImgsInfo[this.onImg];
      }
      if(this.$isEmpty(this.addInfo.kksj)){
        this.$message({message: '请选择开课时间！',type: 'warning'});
        return;
      }else{
        this.addInfo.startTime = this.addInfo.kksj[0]
        this.addInfo.endTime = this.addInfo.kksj[1];
        this.addInfo.kksj = null;
      }

      let url = "/jlw/teacherOpenCourse/add.json";
      if(!this.$isEmpty(this.addInfo.teacherOpenCourseId)){
        url = "/jlw/teacherOpenCourse/edit.json";
      }
      this.$post(url,this.addInfo).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.addCourseShow = false;
          this.$refs.richText.content = ""; //清空编辑框
          this.$message({message: '操作成功！',type: 'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    editCourse(item){ //编辑课程
      this.addInfo = Object.assign({}, item);;
      this.addInfo.kksj = [item.startTime,item.endTime];
      this.onImg = -1;
      this.addCourseShow = true;
      let this_ = this;
      setTimeout(function(){
        this_.$refs.picture.imageUrl = this_.$isHttp(item.teacherOpenCourseCover);
      },10);
    },
    delCourse(item){ //删除课程
      this.$confirm('是否确定删除该课程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/jlw/teacherOpenCourse/delete.json",{ids:item.teacherOpenCourseId}).then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({message: '删除成功！',type: 'success'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    move(item,moveType){ //移动位置
      let param = {teacherOpenCourseId:item.teacherOpenCourseId,moveType:moveType};
      this.$post("/api/teacherOpenCourseMergeTeacher/move.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message({message: '操作成功！',type: 'success'});
        }
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-MyCourse_t{
    padding: 20px 20px 0;

    .cz_li{
      padding: 8px 0;position: absolute;top: 116px;width: 100%;background-color: #2789E2;color: white;font-size: 14px;
    }
    .content_block{
      background-color: #ffffff;
      .ulClass{
        list-style-type:none;
        margin: 0;
        padding: 0;
        li{
          float: left;
          // width: calc(20% - 22px);
          min-height: 275px;
          width: 222px;
          text-align: center;
          margin: 10px;
          border: 1px solid #E1E1E1;
          border-radius: 5px;
          img,.course_img{
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
          }
        }
        li:hover{
          border-color: #409EFF;
        }
      }
      .courseSummary{
        p{
          margin: 0;
        }
      }
    }
    .course_img{
      width: 100%;
      height: 151px;
    }
    .course_min_img{
      width: 40px;
      height: 40px;
    }
    .jiarukec_img{
      width: 10%;
      min-width: 50px;
      margin-top: 35%;
    }
    .hover_course_img{
      position: absolute;background-color: #131F49;top: 0;opacity:0.8;
      color: #ffffff;
      display: flex;
      justify-content:center;
      align-items:center;
      p{
        margin: 0;
        cursor: pointer;
      }
    }

    /deep/ .el-form-item{
      margin-bottom:10px;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 164px;
      height: 89px;
      line-height: 89px;
      text-align: center;
    }
    .avatar {
      width: 164px;
      height: 89px;
      display: block;
    }

    // @media screen and (min-width:2000px){
    //   li{
    //     width: calc(20% - 24px);
    //   }
    // }

  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/MyCourse.vue